module.exports = __webpack_public_path__ + "img/preguicinha-home.1272ec76.svg";